export default __webpack_public_path__ + "static/media/thumbnail.5e590548.png";